import styled from 'styled-components';

export const StyledTitle = styled.div`
  font: 400 16px/20px ${({ theme }) => theme.fonts.join()};
  margin-bottom: 29px;
`;
